import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { times } from 'lodash';

import { useGetPracticeSettings } from 'store/settings/selectors';
import type { Faq } from 'types/entities/faq';

export function useDefaultFaq() {
  const intl = useIntl();
  const { privacyPolicyUrl } = useGetPracticeSettings();

  return useMemo<Faq>(
    () => ({
      faqSections: [
        {
          title: intl.formatMessage({ id: 'faq.title' }),
          faqQuestions: times(4, index => {
            const messagePrefix = `faq.defaultContent.${[index + 1]}`;

            return {
              title: String(intl.formatMessage({ id: `${messagePrefix}.question` })),
              description: String(
                intl.formatMessage(
                  { id: `${messagePrefix}.answer` },
                  {
                    privacyPolicyUrl,
                  }
                )
              ),
            };
          }),
        },
      ],
    }),
    [intl, privacyPolicyUrl]
  );
}
